import React from "react";
import dayjs from "dayjs";
import { AddOnBox } from "./styles";

export interface AddOnProps {
  count: number;
}

const AddOn = ({ count }: AddOnProps) => {
  const number = count?.toLocaleString();
  const date = dayjs().utc().format("YYYY-MM-DD");
  return <AddOnBox>{number} Templates are preparing</AddOnBox>;
};

export default AddOn;
